<template>
  <div>
    <GroupHeader :width="423" :left="1428" :top="632" :title="$t('Monitoring1025.alarm')" />
    <div class="alarm-container" :style="{ width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px' }">
      <ul class="head">
        <li class="head-title1">{{ $t('Monitoring1025.time') }}</li>
        <li class="head-title2">{{ $t('Monitoring1025.type') }}</li>
        <li class="head-title3">{{ $t('Monitoring1025.content') }}</li>
      </ul>
      <div class="warp">
        <template v-if="listData.length">
          <vue-seamless-scroll :data="listData" :class-option="classOption" class="warp">
            <div v-for="(item, index) in listData" :key="index" :class="{ head: true, 'item-highlight': index % 2 == 0 }">
              <span class="head-title1" v-text="item.date"></span>
              <span class="head-title2" v-text="item.type"></span>
              <span class="head-title3" v-text="item.content"></span>
            </div>
          </vue-seamless-scroll>
        </template>
        <template v-else>
          <div class="no-data">No Alarm Data</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import GroupHeader from './GroupHeader.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  props: {
    width: {
      type: Number,
      default: 403
    },
    height: {
      type: Number,
      default: 344
    },
    left: {
      type: Number,
      default: 1428
    },
    top: {
      type: Number,
      default: 678
    },
    warmData: {
      type: Array,
      default: null
    }
  },
  components: { GroupHeader, vueSeamlessScroll },
  data() {
    return {
      classOption: {
        step: 0.2
      }
    }
  },
  computed: {
    listData() {
      if (this.warmData == null) return []
      let results = []
      for (let i = 0; i < this.warmData.length; i++) {
        let item = this.warmData[i]
        let res = {}
        res['date'] = this.convertToUTCTime(item.CreateTime)
        res['type'] = this.getAlarmTypeOfKey(item.SysKey)
        res['content'] = this.getAlarmConteOfKey(item)
        results.push(res)
      }
      return results
    },
    currentLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    convertToUTCTime(beijingTimeStr) {
      // 北京时间字符串格式：2025/11/18 2:50:42
      // 北京时间 UTC+8，转换为 UTC 时间需要减去8小时
      if (!beijingTimeStr) return ''

      // 解析北京时间字符串
      const beijingTime = new Date(beijingTimeStr)

      // 减去8小时转换为 UTC 时间
      const utcTime = new Date(beijingTime.getTime() - 8 * 60 * 60 * 1000)

      // 格式化为相同格式的字符串
      const year = utcTime.getFullYear()
      const month = utcTime.getMonth() + 1
      const day = utcTime.getDate()
      const hour = utcTime.getHours()
      const minute = utcTime.getMinutes()
      const second = utcTime.getSeconds()

      return `${year}/${month}/${day} ${hour}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`
    },
    getAlarmTypeOfKey(key) {
      let str = ''
      switch (key) {
        case 'over_side_sms':
          str = this.$t(`Monitoring1025.overSideAlarm`)
          break
        case 'leak_water_sms':
          str = this.$t(`Monitoring1025.leakWaterAlarm`)
          break
        case 'no_data_sms':
          str = this.$t(`Monitoring1025.timeOutAlarm`)
          break
        case 'out_limit_data_sms':
          str = this.$t(`Monitoring1025.outLimitAlarm`)
          break
        case 'error_data_sms':
          str = this.$t(`Monitoring1025.errorDataAlarm`)
          break
      }
      return str
    },
    getAlarmConteOfKey(item) {
      let str = ''
      let key = item.SysKey
      switch (key) {
        case 'over_side_sms':
          str = this.$t(`Monitoring1025.overSideAlarmContent`, [item.eval])
          break
        case 'leak_water_sms':
          str = this.$t(`Monitoring1025.leakWaterAlarmContent`)
          break
        case 'no_data_sms':
          str = this.$t(`Monitoring1025.timeOutAlarmContent`)
          break
        case 'out_limit_data_sms':
          {
            let val = item.eval
            let max = item.emax
            let min = item.emin
            let index = item.EquipmentParamNM.indexOf('(')
            let type = ''
            let unit = ''
            if (index != -1) {
              type = item.EquipmentParamNM.substring(0, index)
              unit = item.EquipmentParamNM.substring(index + 1, item.EquipmentParamNM.length - 1)
            }
            let bigger = val > max
            let smaller = val < min
            if (this.currentLanguage == 'zh') {
              let limit = bigger ? '超过上限' : smaller ? '低于下限' : '在正常范围'
              let limitValue = bigger ? max : smaller ? min : ''
              str = `设备${type}已${limit}${limitValue}${unit}，请注意设备的测量情况。`
            } else {
              let limit = bigger ? 'upper limit' : smaller ? 'lower limit' : 'normal'
              let limitValue = bigger ? max : smaller ? min : ''
              str = `The device measurement ${type} has exceeded the ${limit} ${limitValue}${unit}. Please pay attention to the equipment measurement.`
            }
          }
          break
        case 'error_data_sms':
          str = this.$t(`Monitoring1025.errorDataAlarmContent`)
          break
      }
      return str
    }
  },
  created() {},
  async mounted() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.alarm-container {
  position: absolute;
  padding: 10px 20px 20px 20px;
  font-size: 11px;
  color: #f9fafa;
  .head {
    display: flex;
    align-items: center;
    font-weight: bold;
    padding: 8px 0;
    .head-title1 {
      width: 120px;
      padding-left: 10px;
    }
    .head-title2 {
      width: 100px;
    }
    .head-title3 {
      flex: 1;
      padding-right: 10px;
    }
  }

  .warp {
    overflow: hidden;
    height: 280px;
    margin-bottom: 20px;
  }

  .item-highlight {
    background: rgba(23, 78, 128, 0.4);
    border-radius: 12px 12px 12px 12px;
  }

  .no-data {
    width: 100%;
    text-align: center;
    line-height: 280px;
    color: white;
    font-size: 14px;
    background-color: rgba(23, 78, 128, 0.4);
  }
}
</style>
